import React from 'react';
import "../../../components/sandbox/index.css"
import {Arguments} from "../common/Arguments";


const baseUrl = Arguments.reactUrl.replace("/#", "") + "/att/documents/social/"
const ChangeRelationship = () => {
    return (
        <>
            <div>
                <div className="panel panel-default mt-20">
                    <p style={{fontWeight: 'bold', marginLeft: 20, fontSize: 20}}>社会团体变更</p>
                </div>
                <div className="panel panel-default mt-20">
                    <div className="panel-header">（一）变更名称</div>
                    <div className="panel-body">
                        <p>1．召开理事会或常务理事会，讨论通过变更名称事宜。</p>
                        <p>2．向市社科联提交如下材料：</p>
                        <p> （1）变更申请。《关于天津市××××变更名称的请示》<a
                            href={`${baseUrl}关于天津市××××变更名称的请示.docx`} style={{color: "blue"}}>点此下载</a></p>
                        <p> （2）理事会或常务理事会会议纪要及会议签到单（社团负责人签字，加盖社团公章）。</p>
                        <p>3．市社科联审查同意后，持市社科联的批复向市民政局提交变更申请。</p>
                        <p>4．市民政局审查批准后，办理变更手续（社会团体法人证书变更及组织结构代码证变更）。</p>
                        <p>5．将市民政局的有关批复材料报市社科联备案（15个工作日内）。</p>
                    </div>
                    <div className="panel-header">（二）变更法定代表人</div>
                    <div className="panel-body">
                        <p>1．社团酝酿变更法定代表人初步人选。</p>
                        <p>2．社团向市社科联提交社团拟任法定代表人推荐表。<a
                            href={`${baseUrl}天津市××××拟任法定代表人推荐表.docx`} style={{color: "blue"}}>点此下载</a>
                        </p>
                        <p>3．市社科联对社团拟变更法定代表人初步人选进行审查把关。</p>
                        <p>4．社团拟变更法定代表人初步人选经市社科联审查同意后，社团组织召开理事会，表决通过法定代表人变更事宜。</p>
                        <p>5．向市社科联提交如下材料：</p>
                        <p> （1）变更申请。《关于天津市××××变更法定代表人的请示》<a
                            href={`${baseUrl}关于天津市××××变更法定代表人的请示.docx`}
                            style={{color: "blue"}}>点此下载</a></p>
                        <p> （2）理事会或常务理事会会议签到单及会议纪要（社团负责人签字，加盖社团公章）。</p>
                        <p>6．社团做法定代表人离任审计并报社科联审阅。</p>
                        <p>7．经审查同意后，社团持市社科联的批复向市民政局提交申请。</p>
                        <p>8．市民政局审查批准后，办理变更手续（社会团体法人证书变更）。</p>
                        <p>9．将市民政局的有关批复材料报市社科联备案（15个工作日内）。</p>
                    </div>
                    <div className="panel-header">（三）届中变更负责人（理事长、副理事长、秘书长）</div>
                    <div className="panel-body">
                        <p>1．社团酝酿变更负责人初步人选。</p>
                        <p>2．社团向市社科联提交社团拟变更负责人推荐表。</p>
                        <p>3．市社科联对社团拟变更负责人初步人选进行审查把关。</p>
                        <p>4．社团拟变更负责人初步人选经市社科联审查同意后，社团组织召开理事会，表决通过负责人变更事宜。</p>
                        <p>5．向市社科联提交如下材料：</p>
                        <p> （1）变更申请。《关于天津市××××变更负责人的请示》
                            <a href={`${baseUrl}关于天津市××××变更负责人的请示.docx`} style={{color: "blue"}}>点此下载</a>
                        </p>
                        <p> （2）《天津市××××拟任负责人推荐表》<a href={`${baseUrl}天津市××××拟任负责人推荐表.docx`}
                                                              style={{color: "blue"}}>点此下载</a></p>
                        <p> （3）理事会或常务理事会会议签到单及会议纪要（社团负责人签字，加盖社团公章）。</p>
                        <p>6．市社科联审查同意后，持市社科联的批复向市民政局提交《重大事项报告备案表》。</p>
                        <p>7．市民政局审查批准后，办理变更备案手续。</p>
                    </div>
                    <div className="panel-header">（四）届中章程变更核准</div>
                    <div className="panel-body">
                        <p>1．召开理事会或常务理事会，提出届中变更章程动议。</p>
                        <p>2．本社团变更章程须依照章程规定经会员（代表）大会表决通过，会前填报《重大事项报告备案表》。</p>
                        <p>3.向市社科联提交如下材料：</p>
                        <p> （1）变更申请。《关于天津市××××变更章程的请示》
                            <a href={`${baseUrl}关于天津市××××变更章程的请示.docx`} style={{color: "blue"}}>点此下载</a></p>
                        <p> （2）会员（代表）大会会议纪要（加盖社团公章及参会人员签名）。</p>
                        <p>4．经审查同意后，社团持市社科联审批的社团章程核准表向市民政局提交申请。</p>
                        <p>5．市民政局审查批准后，办理变更手续。</p>
                    </div>
                    <div className="panel-header">（五）变更住所</div>
                    <div className="panel-body">
                        <p>1．社团提交《关于天津市××××变更住所的说明》。
                            <a href={`${baseUrl}关于天津市××××变更住所的说明.docx`} style={{color: "blue"}}>点此下载</a></p>
                    </div>
                    <div className="panel-header">（六）变更监事（长）</div>
                    <div className="panel-body">
                        <p>1．社团酝酿变更监事（长）初步人选。</p>
                        <p>2．社团向市社科联提交社团拟变更监事（长）基本情况表
                            <a href={`${baseUrl}天津市××××第×届监事（长）拟变更人选基本情况表.docx`}
                            style={{color: "blue"}}>点此下载</a></p>
                        <p>3．市社科联对社团拟变更监事（长）初步人选进行审查把关。</p>
                        <p>4．社团拟变更监事（长）初步人选经市社科联审查同意后，社团组织召开理事会，表决通过监事（长）变更事宜。</p>
                        <p>5．向市社科联提交如下材料：</p>
                        <p>（1）《天津市××××第×届监事会（监事）基本情况表》（盖社团章）。
                            <a href={`${baseUrl}天津市××××第×届监事会（监事）基本情况表.docx`}
                            style={{color: "blue"}}>点此下载</a></p>
                        <p>（2）理事会或常务理事会会议纪要及会议签到单（社团负责人签字，加盖社团公章）。
                        </p><p>6．市民政局审查批准后，办理变更备案手续。</p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ChangeRelationship;
